import { useStaticQuery, graphql } from 'gatsby'

export const useMobileCtaQuery = () => {
  const { wp, wpPage } = useStaticQuery(graphql`
    query MobileCtaQuery {
      wp {
        acfOptionsCommonItems {
          commonItems {
            phoneNumber
          }
        }
      }
      wpPage(title: { eq: "Home" }) {
        ctaBar {
          ctaBar {
            ctas {
              icon {
                localFile {
                  publicURL
                }
              }
              buttonText
              link {
                url
                title
              }
            }
          }
        }
      }
    }
  `)
  return { wp, wpPage }
}
